import { useQuery } from "@tanstack/react-query";
import { axiosGet } from "@/services/axiosService";

export default function useTelegramConfig() {
  return useQuery({
    queryKey: ["configurations", "telegram"],
    queryFn: async () => {
      const response = await axiosGet(
        "/configurations/getAppConfig?siteName=telegram",
      );
      if (!response.data) throw new Error("No data received ");

      return response.data ?? [];
    },
    staleTime: Infinity,
  });
}
